import i18n from '@/i18n'
import { TAB_CATEGORY } from '@/constant/permission'
import ManagementLayout from '../layout/managementLayout.vue'

import auditLogManagementRoute from './auditLogManagement/route'
import jobBoardPointRoute from './jobBoardPointDashboard/route'
import userManagementRoute from './userManagement/route'
import companyManagementRoute from './companyManagement/route'
import roleManagementRoute from './roleManagement/route'
import hmManagementRoute from './hmManagement/route'
import employeeManagementRoute from './employeeManagement/route'
import alumniManagementRoute from './alumniManagement/route'
import jobSettingManagementRoute from './jobSettingManagement/route'
import weChatTemplateRoute from './weChatMessageTemplateManagement/route'
import customLandingPageRoute from './customLandingPage/route'
import jobPosterManagementRoute from './jobPosterManagement/route'
import agencyManagementRoute from './agencyManagement/route'
import customJobDetailPageRoute from './customJobDetailPage/route'
import openApiManagementRoute from './openApi/route'
import jobLocationManagementRoute from './jobLocationManagement/route'
import jobTemplateManagementRoute from './jobTemplateManagement/route'
import questionnaireTemplateRoute from './openQuestionTemplateManagement/route'
import questionnaireManagementRoute from './questionnaireManagement/route'
import candidateStatusManagementRoute from './candidateStatusManagement/route'
import customJobFilterManagementRoute from './customJobFilterManagement/route'
import sourceChannelManagementRoute from './sourceChannelManagement/route'
import offerLetterInviteRecordManagementRoute from './offerLetterInviteRecordManagement/route'
import customCompanyTheme from './customCompanyTheme/route'
import cashManagementRoute from './cashManagement/route'
import pointsManagementRoute from './pointsManagement/route'
import onboardingManagementRoute from './onboardingManagement/route'
import onboardingInvitationRoute from './onboardingInvitation/route'
import satisfactionSurveyManagementRoute from './satisfactionSurveyManagement/route'
import jobPostingManagementRoute from './jobPostingManagement/route'
import applicationStatusNotificationTemplate from './applicantStatusNotificationTemplate/route'
import companyPolicyManagement from './companyPolicyManagement/route'
import notificationManagement from './notificationManagement/route'
import applicantLockRoute from './applicantLockManagement/route'
import applicantStatusAutoChangeRoute from './applicantStatusAutoChangeManagement/route'
import postApplicantManagementRoute from './postApplicantManagement/route'
import postApplicantInvitationRoute from './postApplicantInvitation/route'
import jobApplicationManagementRoute from './jobApplicationManagement/route'
import jobApplicationInvitationRoute from './jobApplicationInvitation/route'
import jobPostingChannelAccountManagement from './jobPostingChannelAccountManagement/route'
import thirdIntegrationConfigManagementRoute from './thirdIntegrationConfigManagement/route'
import interviewMeetingRoomManagementRoute from './interviewMeetingRoomManagement/route'
import aiChatbotConfigManagementRoute from './aiChatbotConfigManagement/route'

const pathPrefix = '/v-admin/company-admin'

const routes = [
  userManagementRoute,
  roleManagementRoute,
  auditLogManagementRoute,
  companyManagementRoute,
  hmManagementRoute,
  jobLocationManagementRoute,
  jobTemplateManagementRoute,
  questionnaireTemplateRoute,
  questionnaireManagementRoute,
  // {
  //   name: 'emailManagement',
  //   path: '/email-management',
  //   component: null,
  //   meta: {
  //     permission: 'PERM_EDIT_EMAIL_TEMPLATE',
  //     get title () {
  //       return i18n.t('admin.company.emailManagement.title')
  //     },
  //     menu: {
  //       get label () {
  //         return i18n.t('admin.company.emailManagement.menu')
  //       },
  //       group: COMPANY_ADMIN_MENU_GROUP_KEY.CUSTOMER_BRAND
  //     }
  //   }
  // },
  // {
  //   name: 'customMobileLandingPage',
  //   path: '/custom-landing-page',
  //   component: null,
  //   meta: {
  //     permission: ['PERM_EDIT_MOBILE_LANDING_PAGE', 'PREMIUM_CUSTOM_MOBILE_LANDING_PAGE'],
  //     get title () {
  //       return i18n.t('admin.company.customMobileLandingPage.title')
  //     },
  //     menu: {
  //       get label () {
  //         return i18n.t('admin.company.customMobileLandingPage.menu')
  //       },
  //       group: COMPANY_ADMIN_MENU_GROUP_KEY.CUSTOMER_BRAND
  //     }
  //   }
  // },
  customLandingPageRoute,
  customJobDetailPageRoute,
  // {
  //   name: 'customJobDetailPage',
  //   path: '/customize-job-detail-page',
  //   component: null,
  //   meta: {
  //     permission: [
  //       'PERM_CUSTOMIZE_JOB_DETAIL_PAGE',
  //       'PREMIUM_CUSTOM_JOB_DETAIL',
  //       'PREMIUM_CUSTOM_JOB_DETAIL_COMPANY_LEVEL'
  //     ],
  //     get title () {
  //       return i18n.t('admin.company.customJobDetailPage.title')
  //     },
  //     menu: {
  //       get label () {
  //         return i18n.t('admin.company.customJobDetailPage.menu')
  //       },
  //       group: COMPANY_ADMIN_MENU_GROUP_KEY.CUSTOMER_BRAND
  //     }
  //   }
  // },
  // {
  //   name: 'exportData',
  //   path: '/company-export-data',
  //   component: null,
  //   meta: {
  //     permission: ['PERM_COMPANY_EXPORT_DATA', 'PREMIUM_EXPORT_DATA'],
  //     get title () {
  //       return i18n.t('admin.company.exportData.title')
  //     },
  //     menu: {
  //       get label () {
  //         return i18n.t('admin.company.exportData.menu')
  //       },
  //       group: COMPANY_ADMIN_MENU_GROUP_KEY.DATA
  //     }
  //   }
  // },
  // {
  //   name: 'elcExportData',
  //   path: '/elc-export-apply-data',
  //   component: null,
  //   meta: {
  //     permission: 'COMPUTED_COMPANY_IS_ELC',
  //     get title () {
  //       return i18n.t('admin.company.elcExportData.title')
  //     },
  //     menu: {
  //       get label () {
  //         return i18n.t('admin.company.elcExportData.menu')
  //       },
  //       group: COMPANY_ADMIN_MENU_GROUP_KEY.DATA
  //     }
  //   }
  // },
  // {
  //   name: 'dashboard',
  //   path: '/dashboard',
  //   component: null,
  //   meta: {
  //     permission: 'PERM_DASHBOARD',
  //     get title () {
  //       return i18n.t('admin.company.dashboard.title')
  //     },
  //     menu: {
  //       get label () {
  //         return i18n.t('admin.company.dashboard.menu')
  //       },
  //       group: COMPANY_ADMIN_MENU_GROUP_KEY.DATA
  //     }
  //   }
  // },
  // {
  //   name: 'companyData',
  //   path: '/company-data',
  //   component: null,
  //   meta: {
  //     permission: 'PERM_DASHBOARD',
  //     get title () {
  //       return i18n.t('admin.company.companyData.title')
  //     },
  //     menu: {
  //       get label () {
  //         return i18n.t('admin.company.companyData.menu')
  //       },
  //       group: COMPANY_ADMIN_MENU_GROUP_KEY.DATA
  //     }
  //   }
  // },
  // {
  //   name: 'companyUserData',
  //   path: '/company-user-data',
  //   component: null,
  //   meta: {
  //     permission: 'PERM_DASHBOARD',
  //     get title () {
  //       return i18n.t('admin.company.companyUserData.title')
  //     },
  //     menu: {
  //       get label () {
  //         return i18n.t('admin.company.companyUserData.menu')
  //       },
  //       group: COMPANY_ADMIN_MENU_GROUP_KEY.DATA
  //     }
  //   }
  // },
  candidateStatusManagementRoute,
  agencyManagementRoute,
  customJobFilterManagementRoute,
  weChatTemplateRoute,
  // {
  //   name: 'weChatTemplateMessageManagement',
  //   path: '/wechat-template-message-management',
  //   component: null,
  //   meta: {
  //     permission: ['PERM_WECHAT_TEMPLATE_MESSAGE_MANAGEMENT', 'PREMIUM_WECHAT_TEMPLATE_MESSAGE'],
  //     get title () {
  //       return i18n.t('admin.company.weChatTemplateMessageManagement.title')
  //     },
  //     menu: {
  //       get label () {
  //         return i18n.t('admin.company.weChatTemplateMessageManagement.menu')
  //       },
  //       group: COMPANY_ADMIN_MENU_GROUP_KEY.CUSTOMER_BRAND
  //     }
  //   }
  // },
  employeeManagementRoute,
  onboardingManagementRoute,
  onboardingInvitationRoute,
  offerLetterInviteRecordManagementRoute,
  jobPosterManagementRoute,
  jobPostingManagementRoute,
  satisfactionSurveyManagementRoute,
  postApplicantManagementRoute,
  postApplicantInvitationRoute,
  jobApplicationManagementRoute,
  jobApplicationInvitationRoute,
  cashManagementRoute,
  pointsManagementRoute,
  // {
  //   name: 'companyCashManagement',
  //   path: '/referral/cash-management/',
  //   component: null,
  //   meta: {
  //     permission: ['PERM_REFERRAL_COMPANY_BALANCE_MANAGEMENT', 'COMPUTED_COMPANY_REFERRAL_ENABLED'],
  //     get title () {
  //       return i18n.t('admin.company.cashManagement.title')
  //     },
  //     menu: {
  //       get label () {
  //         return i18n.t('admin.company.cashManagement.menu')
  //       },
  //       group: COMPANY_ADMIN_MENU_GROUP_KEY.REFERRAL
  //     }
  //   }
  // },
  // {
  //   name: 'companyPointsManagement',
  //   path: '/referral/points-management/',
  //   component: null,
  //   meta: {
  //     permission: ['PERM_REFERRAL_COMPANY_BALANCE_MANAGEMENT', 'COMPUTED_COMPANY_REFERRAL_ENABLED', 'PREMIUM_REFERRAL_POINTS_REWARDS'],
  //     titleI18nKey: 'admin.company.pointsManagement.title',
  //     menu: {
  //       get label () {
  //         return i18n.t('admin.company.pointsManagement.menu')
  //       },
  //       group: COMPANY_ADMIN_MENU_GROUP_KEY.REFERRAL
  //     }
  //   }
  // },
  sourceChannelManagementRoute,
  applicantLockRoute,
  applicantStatusAutoChangeRoute,
  alumniManagementRoute,
  notificationManagement,
  applicationStatusNotificationTemplate,
  companyPolicyManagement,
  jobBoardPointRoute,
  jobSettingManagementRoute,
  openApiManagementRoute,
  customCompanyTheme,
  jobPostingChannelAccountManagement,
  thirdIntegrationConfigManagementRoute,
  interviewMeetingRoomManagementRoute,
  aiChatbotConfigManagementRoute
]

const companyAdminRoute = {
  name: 'companyAdminLayout_New',
  path: pathPrefix,
  component: ManagementLayout,
  meta: {
    isInclude: true,
    isRootLayout: true,
    breadcrumb: { hidden: true },
    permission: TAB_CATEGORY.COMPANY_ADMIN,
    get title () {
      return i18n.t('admin.company.title')
    },
    tab: {
      get label () {
        return i18n.t('admin.company.tab')
      }
    },
    hasGroup: true
  },
  children: routes
}

export default companyAdminRoute
